<flyfreely-sidebar></flyfreely-sidebar>
<dynamic-help-editor *ngIf="showDynamicHelpEdit$ | async"></dynamic-help-editor>
<!-- Since many of the components now get the organisation and its ID from the activated state and workspaceStateService now, wait for these to become available -->
<div
    class="workspace-container fill"
    *ngIf="organisationId && currentOrganisationLoaded"
>
    <div style="position: relative">
        <div
            *ngIf="systemNotice != null"
            class="alert alert-warning"
            style="margin: 0"
        >
            <span class="fal fa-info-circle right-buffer left-buffer"></span
            ><span [innerHtml]="systemNotice"></span>
        </div>
        <subscription-banner
            *ngIf="systemNotice == null"
            (createOrganisation)="showCreateCommercialOrganisation()"
            (requestAccess)="requestAccess()"
        ></subscription-banner>
        <div
            *ngIf="
                sharedService.currentOrganisation$
                    | async as currentOrganisation
            "
            style="
                position: absolute;
                left: 50%;
                margin-top: 10px;
                z-index: 1000;
            "
        >
            <div style="left: -50%; position: relative">
                <div *ngIf="showNavigation">
                    <section-selector></section-selector>
                </div>
            </div>
        </div>
        <div
            style="
                position: absolute;
                right: 30px;
                margin-top: 10px;
                z-index: 1000;
            "
        >
            <div dropdown>
                <button
                    dropdownToggle
                    class="btn btn-default"
                    style="
                        display: flex;
                        align-items: center;
                        border-radius: 360px;
                        border: 1px solid #343a40;
                        background: #cacad8;
                    "
                    type="button"
                    tooltip="User profile menu"
                    placement="left"
                    data-cy="userProfileDropdown"
                >
                    <profile-picture
                        *ngIf="currentUser"
                        class="right-buffer"
                        style="display: inline-block"
                        [personId]="currentUser.id"
                        [managingOrganisationId]="
                            currentUser.personalOrganisationId
                        "
                        [width]="20"
                        [height]="20"
                        [shadow]="false"
                    >
                    </profile-picture>
                    &nbsp;
                    <span class="right-buffer">
                        {{
                            currentUser
                                ? currentUser.firstName +
                                  ' ' +
                                  currentUser.lastName
                                : ''
                        }}
                    </span>
                    <span class="caret"></span>
                </button>
                <ul
                    class="dropdown-menu dropdown-menu-right"
                    *dropdownMenu
                    role="menu"
                >
                    <li>
                        <a
                            class="nav-link"
                            relativeRouterLink="userprofile"
                            data-cy="userProfileSelection"
                            ><span class="fa fa-user" aria-hidden="true"></span>
                            Profile</a
                        >
                    </li>
                    <li *ngIf="canAdminOrganisation">
                        <a class="nav-link" (click)="showOrgAdmin()"
                            ><span class="fa fa-gear" aria-hidden="true"></span>
                            Organisation Admin</a
                        >
                    </li>
                    <li>
                        <a
                            class="nav-link"
                            (click)="showAllWhatsNew()"
                            angulartics2On="click"
                            angularticsCategory="help"
                            angularticsAction="whats-new-profile-menu"
                            ><span class="fa fa-gift" aria-hidden="true"></span>
                            What's New</a
                        >
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li>
                        <a class="nav-link" (click)="logout()"
                            ><span
                                class="fa fa-right-from-bracket"
                                aria-hidden="true"
                            ></span>
                            Logout</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <router-outlet></router-outlet>

    <ng-container
        *ngIf="
            sharedService.currentOrganisation$ | async as currentOrganisation
        "
    >
        <div
            class="col-xs-12 col-lg-12 top-buffer"
            *ngIf="currentOrganisation.type === 'no_access'"
        >
            <div class="alert alert-warning">
                You do not have access to this organisation. Please select from
                the available organisations in the left hand navigation bar.
            </div>
        </div>
        <div
            class="col-xs-12 col-lg-12 top-buffer"
            *ngIf="
                currentOrganisation.type === 'no_licence' &&
                !currentOrganisation.organisation.owner
            "
        >
            <div class="alert alert-warning">
                You do not have an active licence to use FlyFreely in this
                organisation. Please contact the organisation administrators to
                be assigned a licence.
            </div>
        </div>

        <div
            class="col-xs-12 col-lg-12"
            *ngIf="
                currentOrganisation.type === 'no_licence' &&
                currentOrganisation.organisation.owner
            "
        >
            <div class="alert alert-warning">
                You do not have an active licence to use FlyFreely in this
                organisation. Please setup a subscription to gain access to this
                organisation.
            </div>
        </div>
        <router-outlet
            *ngIf="currentOrganisation.type === 'organisation_loaded'"
            name="workspace"
        ></router-outlet>
    </ng-container>
</div>
<component-bubble *ngIf="showAlternativeSupport"
    ><iframe [src]="alternativeSupportUrl" style="border: 0"></iframe
></component-bubble>
